import { useFlags } from '@flagsmith/flagsmith/react'
import type { AnySchema } from 'yup'
import { type FeatureFlags, FeatureFlagsSchema } from './flags'

export { LABEL_FAVORECIDO_PADRAO } from './flags'

export function parseFlag<T>(value: unknown, schema: AnySchema): T {
  let parsedValue = value

  if (typeof value === 'string') {
    try {
      parsedValue = JSON.parse(value)
    } catch {
      parsedValue = value
    }
  }

  return schema.validateSync(parsedValue) as T
}

export function useFeatureFlag<T extends keyof FeatureFlags>(
  flagName: T
): FeatureFlags[T] | null {
  const flags = useFlags([flagName])
  const flag = flags[flagName]
  const schema = FeatureFlagsSchema[flagName]

  if (!flag?.enabled) return null

  // Flag ativa sem valor usa os padrões do schema; valor inválido desativa a flag.
  const rawValue = schema.type === 'boolean' ? true : flag.value || '{}'

  try {
    return parseFlag<FeatureFlags[T]>(rawValue, schema)
  } catch {
    return null
  }
}
